import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { signOut } from '../../auth';
import { CONTRAST } from '../../theme';
import { StaticImg } from '../../ui';

const BASENAMES = {
    'Cuyahoga County': '/cuyahoga-county-intel',
    Lansing: '/lansing-mi-intel',
    'Lucas County': '/lucas-county-intel',
};

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  width: 100%;
`;

const Logo = styled(StaticImg)`
  width: 275px;
  margin: 0 auto;
  padding-top: 8px;
  padding-bottom: 8px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  margin: 0px;
  height: 100vh;
  width: 100%;
`;

const ListContainer = styled.div`
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 8px;
    padding: 32px;
    text-align: center;
    margin-top: 65px;
`;

const Title = styled.span`
    font-size: 18px;
    margin-bottom: 25px;
`;

const Submessage = styled.div`
  width: 100%;
  text-align: center;
  padding: 30px 0;
  font-size: 14px;
  color: ${CONTRAST};
`;

const City = styled.a`
  text-decoration: none;
  text-align: center;
  height: 45px;
  color: black;
  padding-top: 20px;
  box-shadow: rgb(165 165 165) 2px 2px 2px 2px;
  border-radius: 8px;
  margin-bottom: 10px;
  font-size: 22px;
`;

const BlogLink = styled.a`
    padding-top: 20px;
    color: black;
`;

const mapState = ({ cities }) => ({ cities });

export const Homepage = () => {
    const dispatch = useDispatch();
    const { cities } = useSelector(mapState);
    const [sentEmail, setSentEmail] = useState(false);

    useEffect(() => {
        if (cities.length === 0 && !sentEmail) {
            dispatch({
                type: 'EMAIL_MARKETING',
            });
            setSentEmail(!sentEmail);
        }
    });

    return (
        <Container>
            <Header>
                <Logo src="/dynamo-primary-logo.png" alt="Dynamo Metrics" />
            </Header>
            {cities.length > 0 ? (
                <ListContainer>
                    <Title>Tools I have access to: </Title>
                    {cities.map((city) => (
                        <City key={city} href={BASENAMES[city]} style={{ cursor: 'pointer' }}>{city}</City>
                    ))}
                    <Submessage onClick={signOut} style={{ cursor: 'pointer' }}>
                        Log Out
                    </Submessage>
                </ListContainer>
            ) : (
                    <ListContainer>
                        <span>
                            Contact help@dynamometrics.com to schedule a demo.
                            See how we help validate and communicate decisions.
                        </span>
                        <BlogLink href="https://www.dynamometrics.com/blog">Dynamo Metrics blog</BlogLink>
                        <Submessage onClick={signOut} style={{ cursor: 'pointer' }}>
                            Log Out
                        </Submessage>
                    </ListContainer>
                )}
        </Container>
    );
};
